const { expect } = require('chai');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

const projectId = 'migratortronTarget';

describe('Migrate content models', () => {
  describe('preview migrating a single content type, component and a default node', () => {
    const mock = loadRecordedMock('migrate_models_simple_preview.json');

    it(`should return one content type, one component and a default node to create`, (done) => {
      migratortronApi.post(
        'migrate/models?simple',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);

          expect(body.status.create).to.be.an('object');
          const { contentTypes, components, nodes } = body.status.create;

          expect(contentTypes).to.be.an('array');
          expect(contentTypes).to.have.a.lengthOf(1);
          expect(components).to.be.an('array');
          expect(components).to.have.a.lengthOf(1);
          expect(nodes).to.be.an('array');
          expect(nodes).to.have.a.lengthOf(2);

          done();
        }
      );
    });
  });

  describe('migrate a single content type, component and a default node', () => {
    const mock = loadRecordedMock('migrate_models_commit_simple.json');

    it(`should create one content type, one component and a default node`, (done) => {
      migratortronApi.post(
        'migrate/models/commit?simple',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          expect(body.errors).to.not.exist;
          if (body.error) done(body.error);

          expect(body.modelsResult[projectId]).to.be.an('object');
          const { contentTypes, components, nodes } =
            body.modelsResult[projectId];

          expect(contentTypes.created).to.be.an('array');
          expect(contentTypes.created).to.have.a.lengthOf(1);
          expect(components.created).to.be.an('array');
          expect(components.created).to.have.a.lengthOf(1);
          expect(nodes.created).to.be.an('array');
          expect(nodes.created).to.have.a.lengthOf(2);
          done();
        }
      );
    });
  });

  describe('repeat the same migrate a single content type, component and a default node', () => {
    const mock = loadRecordedMock('migrate_models_commit_simple_repeat.json');

    it(`should return one content type, one component and a default node`, (done) => {
      migratortronApi.post(
        'migrate/models/commit?simple&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          expect(body.errors).to.not.exist;
          if (body.error) done(body.error);

          expect(body.modelsResult[projectId]).to.be.an('object');
          const { contentTypes, components, nodes } =
            body.modelsResult[projectId];

          expect(contentTypes.unchanged).to.be.an('array');
          // expect(contentTypes.unchanged).to.have.a.lengthOf(1);
          // automotron cms is not saving defaultParentNodeId so this is marked as updated for now
          expect(contentTypes.updated).to.have.a.lengthOf(1);

          expect(components.unchanged).to.be.an('array');
          expect(components.unchanged).to.have.a.lengthOf(1);
          expect(nodes.unchanged).to.be.an('array');
          expect(nodes.unchanged).to.have.a.lengthOf(1);
          done();
        }
      );
    });
  });

  describe('preview migrating a content type with multiple links', () => {
    const mock = loadRecordedMock('migrate_models_linked_preview.json');

    it(`should return multiple content types, components, assets, entries and a default node to create`, (done) => {
      migratortronApi.post(
        'migrate/models?linked',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);

          const { contentTypes, components } = body;
          expect(Object.keys(contentTypes)).to.have.a.lengthOf(2);
          expect(Object.keys(components)).to.have.a.lengthOf(3);

          expect(body.status.create).to.be.an('object');
          expect(body.status['two-pass']).to.be.an('object');
          const { create, ['two-pass']: twoPass } = body.status;

          expect(create.contentTypes).to.be.an('array');
          expect(create.contentTypes).to.have.a.lengthOf(1);
          expect(create.defaults).to.be.an('array');
          expect(create.defaults).to.have.a.lengthOf(3); // 3 entries, 2 images
          // expect(create.nodes).to.be.an('array');
          // expect(create.nodes).to.have.a.lengthOf(1);
          expect(twoPass.contentTypes).to.be.an('array');
          expect(twoPass.contentTypes).to.have.a.lengthOf(1);
          expect(twoPass.components).to.be.an('array');
          expect(twoPass.components).to.have.a.lengthOf(2);

          expect(
            body.contentTypes.linkedContent.projects[projectId].status
          ).equals('two-pass');

          done();
        }
      );
    });
  });

  describe('migrate a content type with multiple links', () => {
    const mock = loadRecordedMock('migrate_models_commit_linked.json');

    it(`should create multiple content types, components, assets, entries and a default node`, (done) => {
      migratortronApi.post(
        'migrate/models/commit?linked',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          expect(body.errors).to.not.exist;
          if (body.error) done(body.error);

          expect(body.modelsResult[projectId]).to.be.an('object');
          const { contentTypes, components, defaults, nodes } =
            body.modelsResult[projectId];

          expect(contentTypes.created).to.be.an('array');
          expect(contentTypes.created).to.have.a.lengthOf(2);
          expect(defaults.created).to.be.an('array');
          expect(defaults.created).to.have.a.lengthOf(3); // 3 entries, 2 images
          expect(defaults.updated).to.be.an('array');
          expect(defaults.updated).to.have.a.lengthOf(3); // same 3 entries will have been updated after second pass models have loaded
          // expect(nodes.created).to.be.an('array');
          // expect(nodes.created).to.have.a.lengthOf(1);
          expect(components.created).to.be.an('array');
          expect(components.created).to.have.a.lengthOf(2);
          expect(components.unchanged).to.have.a.lengthOf(1);
          done();
        }
      );
    });
  });

  describe('repeat the same migrate a content type with multiple links', () => {
    const mock = loadRecordedMock('migrate_models_commit_linked_repeat.json');

    it(`should return multiple content types, components, assets, entries and a default node`, (done) => {
      migratortronApi.post(
        'migrate/models/commit?linked&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          expect(body.errors).to.not.exist;
          if (body.error) done(body.error);

          expect(body.modelsResult[projectId]).to.be.an('object');
          const { contentTypes, components, defaults, nodes } =
            body.modelsResult[projectId];

          expect(contentTypes.unchanged).to.be.an('array');
          expect(contentTypes.unchanged).to.have.a.lengthOf(2);
          // expect(contentTypes.unchanged).to.have.a.lengthOf(1);
          // // TODO: this should be unchanged cms-automotron is not saving defaultParentNodeId
          // expect(contentTypes.updated).to.have.a.lengthOf(1);

          expect(components.unchanged).to.be.an('array');
          expect(components.unchanged).to.have.a.lengthOf(3);

          expect(defaults.unchanged).to.be.an('array');
          expect(defaults.unchanged).to.have.a.lengthOf(5);
          // expect(nodes.unchanged).to.be.an('array');
          // expect(nodes.unchanged).to.have.a.lengthOf(1);
          done();
        }
      );
    });
  });

  describe('preview migrating a single content type containing multiple resource picker fields', () => {
    const mock = loadRecordedMock('migrate_models_pickers_preview.json');

    it(`should return multiple content types, forms and a tag group to create`, (done) => {
      migratortronApi.post(
        'migrate/models?pickers',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);

          expect(Object.keys(body.contentTypes)).to.have.a.lengthOf(5);
          expect(Object.keys(body.tagGroups)).to.have.a.lengthOf(2);

          expect(body.status).to.be.an('object');
          const {
            create,
            ['two-pass']: twoPass,
            ['no change']: noChange,
          } = body.status;

          expect(create.contentTypes).to.be.an('array').and.have.a.lengthOf(4);
          expect(
            create.contentTypes.filter((c) => c.dataFormat === 'entry')
          ).to.have.a.lengthOf(2);
          expect(
            create.contentTypes.filter((c) => c.dataFormat === 'form')
          ).to.have.a.lengthOf(2);

          expect(twoPass.contentTypes).to.be.an('array').and.have.a.lengthOf(1);
          expect(create.tagGroups).to.be.an('array').and.have.a.lengthOf(1);
          expect(noChange.tagGroups).to.be.an('array').and.have.a.lengthOf(1);

          expect(
            body.contentTypes.resourcePickers.projects[projectId].status
          ).equals('two-pass');

          done();
        }
      );
    });
  });

  describe('migrate a single content type containing multiple resource picker fields', () => {
    const mock = loadRecordedMock('migrate_models_commit_pickers.json');

    it(`should create multiple content types, forms and a tag group`, (done) => {
      migratortronApi.post(
        'migrate/models/commit?pickers',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          expect(body.errors).to.not.exist;
          if (body.error) done(body.error);

          expect(body.modelsResult[projectId]).to.be.an('object');
          const { contentTypes, tagGroups } = body.modelsResult[projectId];

          expect(contentTypes.created).to.be.an('array').and.have.a.lengthOf(5);

          expect(tagGroups.created).to.be.an('array').and.have.a.lengthOf(1);
          expect(tagGroups.unchanged).to.be.an('array').and.have.a.lengthOf(1);

          done();
        }
      );
    });
  });

  describe('repeat the same migrate a single content type containing multiple resource picker fields', () => {
    const mock = loadRecordedMock('migrate_models_commit_pickers_repeat.json');

    it(`should return multiple content types, forms and a tag group`, (done) => {
      migratortronApi.post(
        'migrate/models/commit?pickers&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          expect(body.errors).to.not.exist;
          if (body.error) done(body.error);

          expect(body.modelsResult[projectId]).to.be.an('object');
          const { contentTypes, tagGroups } = body.modelsResult[projectId];

          expect(contentTypes.unchanged)
            .to.be.an('array')
            .and.have.a.lengthOf(5);

          expect(tagGroups.unchanged).to.be.an('array').and.have.a.lengthOf(2);
          done();
        }
      );
    });
  });
});
